import { AddressString } from '~components/providers/types';
import { getContractAddress } from '~config/protocol';
import { ContractNames } from '~config/protocol/contractConfig';

import { useSession } from '../useSession';

export function useContractAddress<T extends ContractNames | ContractNames[]>(
  contractNameOrNames: T,
): T extends ContractNames[] ? AddressString[] : AddressString {
  const {
    network: { networkId },
  } = useSession();

  if (Array.isArray(contractNameOrNames)) {
    return (<ContractNames[]>contractNameOrNames).map(contractName =>
      getContractAddress(contractName, networkId),
    ) as any;
  }
  return getContractAddress(<ContractNames>contractNameOrNames, networkId) as any;
}
